export interface NotificationFilterDto {
  categoryCode?: string;
  fromDate?: string;
  notificationPage: NotificationPage;
  priorityCode?: string;
  searchText?: string;
  tab: NotificationTab;
  toDate?: string;
  type: NotificationType;
}

export enum NotificationType {
  IN = "IN",
  OUT = "OUT",
}

export enum NotificationPage {
  SYSTEM_NOTIFS = "SYSTEM_NOTIFS",
  EXTPERSON_NOTIFS = "EXTPERSON_NOTIFS",
}

export interface BaseNotificationDto {
  guid?: string;
  id?: number;
  message: string;
  topic?: string;
}

export interface NotificationDto extends BaseNotificationDto {
  categoryCode: string;
  category: string;
  dueDate: string;
  execDocGuid: number;
  execDocId: number;
  execDocNum: string;
  execProcNum: string;
  files: {
    dDocGuid: string;
    dDocTitle: string;
    dInDate: string;
  }[];
  fromUser: string;
  important: boolean;
  lawman: string;
  messageHistory: {
    guid: string;
    id: number;
    message: string;
    sendDate: string;
    senderName: string;
    topic: string;
  }[];
  readDate: string;
  sendDate: string;
  toUser: string;
}

export enum NotificationTab {
  ALL = "ALL",
  READ = "READ",
  NOT_READ = "NOT_READ",
}

export interface SideDto {
  name: string;
  side: ExecDocSide;
}
export enum ExecDocSide {
  DEBTOR = "DEBTOR",
  RECOVERER = "RECOVERER",
  TRUSTEE = "TRUSTEE",
}

export interface SendMessage {
  execProcId: number;
  parentGuid: string;
  parentId: number;
  files: SendFiles[] | undefined;
  text: string;
  topic: string;
}

export interface SendFiles {
  content: string;
  fileName: string;
  mimeType: string;
}

export type ExecProc = { guid: string; id: number };
